export default __webpack_public_path__ + "static/media/andromeda.guia-3.04d6b31b.png";